export const SET_ERROR = 'SET_ERROR';

export const setError = error => {
  return {
    type: SET_ERROR,
    payload: {
      ...error,
    },
  };
};

export const clearError = () => {
  return {
    type: SET_ERROR,
    payload: {
      message: null,
    },
  };
};



// WEBPACK FOOTER //
// ./src/actions/error/index.js